export default function ChevronUpIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="chevron-up"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M12.75 29.95q-.6-.6-.625-1.4-.025-.8.575-1.35l9.9-9.9q.3-.3.65-.45.35-.15.75-.15t.75.15q.35.15.65.45l9.9 9.85q.6.55.6 1.375t-.6 1.375q-.6.6-1.425.6-.825 0-1.425-.6L24 21.5 15.55 30q-.55.6-1.375.575-.825-.025-1.425-.625Z"
      />
    </svg>
  );
}
